import { FormField, FormItem, FormLabel, FormControl } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { LucideSparkles, LucideLoader2 } from "lucide-react";

/**
 * A labeled textarea with an "Generate with AI" button below it.
 *
 * Props:
 *   control          - react-hook-form control
 *   name             - form field name
 *   label            - FormLabel text
 *   isGenerating     - boolean; disables the button and shows a spinner when true
 *   onGenerate       - click handler for the AI button
 *   placeholder      - optional textarea placeholder
 *   labelClassName   - optional className override for FormLabel
 *   textareaClassName - optional className override for Textarea (default: "min-h-[100px]")
 *   buttonClassName  - optional className override for the Button
 */
export function AIGeneratedTextarea({
  control,
  name,
  label,
  isGenerating,
  onGenerate,
  placeholder,
  labelClassName,
  textareaClassName = "min-h-[100px]",
  buttonClassName,
}) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel className={labelClassName}>{label}</FormLabel>
          <FormControl>
            <Textarea
              {...field}
              placeholder={placeholder}
              className={textareaClassName}
            />
          </FormControl>
          <div className="flex items-center justify-end mt-1 gap-2">      
            <Button
              type="button"
              variant="outline"
              size="sm"
              disabled={isGenerating}
              onClick={onGenerate}
              className={buttonClassName}
            >
              {isGenerating ? (
                <LucideLoader2 size={14} className="mr-1.5 animate-spin" />
              ) : (
                <LucideSparkles size={14} className="mr-1.5" />
              )}
              Generate with AI
            </Button>
          </div>
        </FormItem>
      )}
    />
  );
}
